import { PERMISSIONS } from "../constants/permissions";
import JWTTokenPayload from "../interfaces/JWTTokenPayload";
import { RootState } from "../store/store";
import { decodedJWT, getOwnerName, getOwnerType, getUserName } from "../utils/commonUtils";

export default class PermissionManagement {
    private static checkPermissionStatus(state: RootState, permissionName: string) {
        const { entityPermissions, permissions, permissionSet } = state;
        const token: false | JWTTokenPayload = decodedJWT();
        const ownerName = getOwnerName(token);
        const ownerType = getOwnerType(token);
        const username = getUserName(token);
        const isPermissionGranted = permissionSet.permissionSet.find(
            val => val.permission_name === permissionName && val.username === username
        )?.is_active && permissions.permissions.find(
            val => val.permission_name === permissionName
        )?.is_active && entityPermissions.entityPermissions.find(
            val => val.entity_type === ownerType && val.entity_name === ownerName && val.permission_name === permissionName
        )?.is_permission_granted;
        return isPermissionGranted;
    }

    public static isDialerEnabled(state: RootState) {
        return !!this.checkPermissionStatus(state, PERMISSIONS.dialer);
    }

	public static isAIDispositionEnabled(state: RootState) {
        return !!this.checkPermissionStatus(state, PERMISSIONS.aiDisposition);
    }

    public static isCampaignEnabled(state: RootState): boolean {
        return !!this.checkPermissionStatus(state, PERMISSIONS.campaign);
    }

    public static isCallCampaignEnabled(state: RootState): boolean {
        return this.isCampaignEnabled(state) && !!this.checkPermissionStatus(state, PERMISSIONS.dialer_campaign);
    }

    public static isDocumentGenerationEnabled(state: RootState): boolean {
        return this.isCampaignEnabled(state) && !!this.checkPermissionStatus(state, PERMISSIONS.document_generation);
    }

	public static isKnowlVoiceBotCampaignEnabled(state: RootState): boolean {
		return this.isCampaignEnabled(state) && !!this.checkPermissionStatus(state, PERMISSIONS.knowl_voice_bot_campaign);
	}

	public static isCraftAiBotCampaignEnabled(state: RootState): boolean {
		return this.isCampaignEnabled(state) && !!this.checkPermissionStatus(state, PERMISSIONS.craft_ai_bot_campaign);
	}

    public static isUserManagementEnabled(state: RootState): boolean {
        return !!this.checkPermissionStatus(state, PERMISSIONS.userManagement);
    }
};